(function () {
    const errorMsg =
        '<p class="global-form__error-msg">Something went wrong with your request. Please try again</p>';
    const inputForm = document.querySelector(
        ".search-results-listing .input-form"
    );

    const initialHref = window.location.href;

    if (!inputForm) {
        return;
    }

    const getSubmitUrl = () => {
        const data = new FormData(inputForm);
        const queryString = new URLSearchParams(data).toString();
        return `${inputForm.dataset.action}?${queryString}`;
    };

    const submit = () => {
        fetchRequest(getSubmitUrl());
    };

    const fetchRequest = (url, replace = false) => {
        const searchResultsDiv = document.querySelector(
            ".search-results-listing .results"
        );
        const { search } = new URL(url);
        const { origin, pathname } = window.location;
        const newUrl = `${origin}${pathname}${search}`;
        if (replace) {
            window.history.replaceState({ url }, "", newUrl);
        } else {
            window.history.pushState({ url }, "", newUrl);
        }

        const errorHandling = () => {
            if (searchResultsDiv) {
                searchResultsDiv.innerHTML = errorMsg;
            }
        };

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("throw error");
                }
                return response.text();
            })
            .then((html) => (inputForm.innerHTML = html))
            .catch(errorHandling);
    };

    const submitHandler = (e) => {
        if (e.type === "keydown" && e.target.name === "query") {
            const inputBox = e.target;
            if (
                e.key === "Backspace" &&
                inputBox.value.replace(/ /g, "").length < 4
            ) {
                inputBox.classList.remove("active");
                inputForm
                    .querySelector(
                        ".search-results-listing .search-container .cancel-logo"
                    )
                    .classList.remove("active");
            } else {
                if (inputBox.value.replace(/ /g, "").length < 2) {
                    inputBox.classList.remove("active");
                    inputForm
                        .querySelector(
                            ".search-results-listing .search-container .cancel-logo"
                        )
                        .classList.remove("active");
                } else {
                    inputBox.classList.add("active");
                    inputForm
                        .querySelector(
                            ".search-results-listing .search-container .cancel-logo"
                        )
                        .classList.add("active");
                }
            }

            if (e.key === "Enter" || e === "submit") {
                e.preventDefault();
                submit();
            }
        }

        if (
            e.type === "change" &&
            (e.target.tagName === "SELECT" || e.target.type === "checkbox")
        ) {
            submit();
        }
    };

    const clickHandler = (e) => {
        const target = e.target;

        // clear Btn
        if (
            target.classList.contains("cancel-logo") ||
            target.parentElement.classList.contains("cancel-logo")
        ) {
            const inputBox = inputForm.querySelector(".search-box");
            inputBox.value = "";
            inputBox.classList.remove("active");
            inputForm
                .querySelector(
                    ".search-results-listing .search-container .cancel-logo"
                )
                .classList.remove("active");
        }
        const selectedFilter = target.closest(".selected");

        if (!!selectedFilter) {
            e.preventDefault();
            const href = selectedFilter.getAttribute("href");
            const url = inputForm.dataset.action + href;
            fetchRequest(url);
        }

        // dropdown menu
        let dropdownMenu = document.querySelector(
            ".result-filters .filter-content"
        );
        if (
            (target.classList.contains("refine-mobile-button") ||
                target.parentElement.classList.contains(
                    "refine-mobile-button"
                )) &&
            dropdownMenu
        ) {
            dropdownMenu.classList.toggle("active");
        }
    };

    window.history.replaceState({ url: initialHref }, "", initialHref);

    inputForm.addEventListener("submit", submitHandler);
    inputForm.addEventListener("change", submitHandler);
    inputForm.addEventListener("keydown", submitHandler);
    inputForm.addEventListener("click", clickHandler);

    window.addEventListener("popstate", (e) => {
        const url = e.state?.url;
        if (url) {
            fetchRequest(url, true);
        }
    });
})();
